'use strict';

import { Entity } from '../Entity';

export class IndPortalLog extends Entity {
  protected id;

  protected ind;

  protected loginDateTime;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.ind = data.ind;

    if (data.loginDateTime && data.loginDateTime != '') {
      const loginDateTime = data.loginDateTime.date.split(' ')[0].split('-');
      this.loginDateTime = loginDateTime[1] + '/' + loginDateTime[2] + '/' + loginDateTime[0];
    }
  }

  public getId() {
    return this.id;
  }

  public getInd() {
    return this.ind;
  }

  public getLoginDateTime() {
    return this.loginDateTime;
  }
}
